// Firebase 初期化 (Q4CL-console と同一プロジェクト q4cl-75834)
;(function () {
  const firebaseConfig = {
    apiKey: 'AIzaSyD-JTJaLrGCuxyuMJPf-QNgFxKZvafiaSo',
    authDomain: 'q4cl-75834.firebaseapp.com',
    databaseURL: 'https://q4cl-75834-default-rtdb.firebaseio.com',
    projectId: 'q4cl-75834',
    storageBucket: 'q4cl-75834.appspot.com',
    messagingSenderId: '364458558738',
    appId: '1:364458558738:web:2b38ad9931c8bb35955fcb'
  };

  if (!firebase.apps.length) {
    firebase.initializeApp(firebaseConfig);
  }

  // 患者の匿名ログイン。 再送信 (同じ answerId の上書き) を送信者本人にだけ許可するため、
  // 送信時に questionnaire/answerowners へ匿名 uid を記録する (database.rules.json 参照)。
  // 失敗しても (匿名認証が無効・オフライン等) null で解決し、 初回送信は従来どおり行える。
  // 匿名アカウントはサーバー側で定期削除する (delete_anonymous_users.php) ため、 端末には保存せず
  // (Persistence.NONE)、 以前の版で保存された匿名ログインも破棄してから毎回新しくログインする。
  const auth = firebase.auth();
  window.q4clAuthReady = auth.setPersistence(firebase.auth.Auth.Persistence.NONE)
    .then(() => auth.signOut())
    .then(() => auth.signInAnonymously())
    .then((cred) => cred.user)
    .catch((e) => {
      console.warn('[firebase] 匿名ログインに失敗 (再送信は不可になります):', e && e.code);
      return null;
    });

  window.firebase = firebase;
  window.firebaseConfig = firebaseConfig;
})();
